module.exports = __webpack_public_path__ + "static/kitchen-prep-square.d3b32c8d.jpg";